import React from "react";
import { Autocomplete, Skeleton, TextField, Checkbox } from "@mui/material";
import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";
import { FilterSKUFulfillmentTypes, useSKUFulfillmentTypesContext } from "../Contexts/skuFulfillmentTypesContext";

const icon = <CheckBoxOutlineBlank fontSize="small" />;
const checkedIcon = <CheckBox fontSize="small" />;

export default function SKUFulfillmentTypeMultiSelection() {
    const {
        skuFulfillmentTypes,
        isReady: areSKUFulfillmentTypesReady,
        selectedSKUFulfillmentTypes,
        setSelectedSKUFulfillmentTypes,
    } = useSKUFulfillmentTypesContext();

    if (!areSKUFulfillmentTypesReady) {
        return (
            <div>
                <Skeleton variant="rectangular" width={250} height={50} />{" "}
            </div>
        );
    }

    return (
        <div>
            {areSKUFulfillmentTypesReady ? (
                <Autocomplete
                    multiple
                    limitTags={1}
                    disablePortal
                    filterOptions={(options, state) =>
                        FilterSKUFulfillmentTypes(options, state.inputValue.toLocaleLowerCase())
                    }
                    id="combo-box-skuFulfillmentType"
                    getOptionLabel={(option) => `${option.description}`}
                    options={skuFulfillmentTypes}
                    disableCloseOnSelect
                    renderOption={(props, option, { selected }) => (
                        <li {...props} key={option.id}>
                            <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={selected}
                            />
                            {option.description}
                        </li>
                    )}
                    sx={{ width: 250 }}
                    renderInput={(params) => (
                        <TextField {...params} label="Select Fulfillment Methods" />
                    )}
                    value={selectedSKUFulfillmentTypes || []}
                    onChange={(event, value) => {
                        setSelectedSKUFulfillmentTypes(value);
                    }}
                />
            ) : (
                    <Skeleton variant="rectangular" width={250} height={50} />
            )}
        </div>
    );
}